module.exports = __webpack_public_path__ + "static/media/3950.c9641a1f.jpg";